import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { LOGGER } from "./logger";
import { RE_DIRECT_TO } from "./redirectHelper";
import { REMOVE_ALL_COOKIE } from "./cookieHelper";
import { GET_LOCAL_STORAGE, LOCAL_STORAGE_KEY } from "./localStorage";
import { CM, FL, ML, PA, PFA, SM } from "../pages/router/AddRoutesJson";

export async function currentAuthenticatedUser() {
  try {
    const session = await fetchAuthSession();

    // LOGGER(JSON.stringify(session.tokens.idToken.payload, null, 5));
    // LOGGER(session?.tokens?.idToken?.toString());
    return session.tokens.idToken.payload;
  } catch (err) {
    LOGGER(err);
  }
}

export const logOut = async () => {
  try {
    const res = await signOut();
    REMOVE_ALL_COOKIE();
    localStorage.clear();
    if (res == undefined) {
      RE_DIRECT_TO("/");
    }
  } catch (error) {
    LOGGER("Error signing out:", error);
  }
};
export const getCurrentRole = () => {
  return GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.selectedRole);
};
export const isCurrentRoleReadOnly = () =>
  [PA].includes(getCurrentRole()) ? true : false;
export const isProjectAdmin = () => [PA].includes(getCurrentRole());
export const isPlatformAdmin = () => [PFA].includes(getCurrentRole());
export const isClientManager = () => [CM].includes(getCurrentRole());
export const isSiteManager = () => [SM].includes(getCurrentRole());
export const isMachineLearning = () => [ML].includes(getCurrentRole());
export const isFederatedLearning = () => [FL].includes(getCurrentRole());
